<template>
  <FriedBreadcrumb>
    <FriedBreadcrumbItem v-for="(breadcrumb, index) in directoryBreadcrumbs" :key="index">
      <FriedParagraph
        :data-external="`dsr-template-picker-breadcrumb:${breadcrumb}-link`"
        @click="handleClick(index, breadcrumb)"
        >{{ breadcrumb || $t('start') }}</FriedParagraph
      >
    </FriedBreadcrumbItem>
  </FriedBreadcrumb>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';

export default defineComponent({
  name: 'TemplateBreadcrumbs',
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  emits: ['goto-directory'],
  setup(props, { emit }) {
    const directoryBreadcrumbs = computed(() => LibraryHelper.getBreadcrumbsFromPath(props.path));

    const handleClick = (index: number, breadcrumb: string) => {
      if (directoryBreadcrumbs.value[directoryBreadcrumbs.value.length - 1] === breadcrumb) {
        return;
      }

      emit(
        'goto-directory',
        LibraryHelper.getPathFromBreadcrumbs(directoryBreadcrumbs.value, index)
      );
    };

    return { directoryBreadcrumbs, handleClick };
  },
});
</script>
